// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/SystemModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";

export const protobufPackage = "daisi.protos.v1";

export enum Timeframe {
  TimeframeSecond = 0,
  TimeframeMinute = 1,
  TimeframeHour = 2,
  TimeframeDay = 3,
  TimeframeWeek = 4,
  TimeframeMonth = 5,
  TimeframeYear = 6,
  UNRECOGNIZED = -1,
}

export function timeframeFromJSON(object: any): Timeframe {
  switch (object) {
    case 0:
    case "TimeframeSecond":
      return Timeframe.TimeframeSecond;
    case 1:
    case "TimeframeMinute":
      return Timeframe.TimeframeMinute;
    case 2:
    case "TimeframeHour":
      return Timeframe.TimeframeHour;
    case 3:
    case "TimeframeDay":
      return Timeframe.TimeframeDay;
    case 4:
    case "TimeframeWeek":
      return Timeframe.TimeframeWeek;
    case 5:
    case "TimeframeMonth":
      return Timeframe.TimeframeMonth;
    case 6:
    case "TimeframeYear":
      return Timeframe.TimeframeYear;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Timeframe.UNRECOGNIZED;
  }
}

export function timeframeToJSON(object: Timeframe): string {
  switch (object) {
    case Timeframe.TimeframeSecond:
      return "TimeframeSecond";
    case Timeframe.TimeframeMinute:
      return "TimeframeMinute";
    case Timeframe.TimeframeHour:
      return "TimeframeHour";
    case Timeframe.TimeframeDay:
      return "TimeframeDay";
    case Timeframe.TimeframeWeek:
      return "TimeframeWeek";
    case Timeframe.TimeframeMonth:
      return "TimeframeMonth";
    case Timeframe.TimeframeYear:
      return "TimeframeYear";
    case Timeframe.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PagingInfo {
  PageIndex?: number | undefined;
  PageSize?: number | undefined;
  SearchTerm?: string | undefined;
  SortColumn?: string | undefined;
}

function createBasePagingInfo(): PagingInfo {
  return { PageIndex: undefined, PageSize: undefined, SearchTerm: undefined, SortColumn: undefined };
}

export const PagingInfo: MessageFns<PagingInfo> = {
  encode(message: PagingInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.PageIndex !== undefined) {
      writer.uint32(8).int32(message.PageIndex);
    }
    if (message.PageSize !== undefined) {
      writer.uint32(16).int32(message.PageSize);
    }
    if (message.SearchTerm !== undefined) {
      writer.uint32(26).string(message.SearchTerm);
    }
    if (message.SortColumn !== undefined) {
      writer.uint32(34).string(message.SortColumn);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PagingInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePagingInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.PageIndex = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.PageSize = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.SearchTerm = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.SortColumn = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PagingInfo {
    return {
      PageIndex: isSet(object.PageIndex) ? globalThis.Number(object.PageIndex) : undefined,
      PageSize: isSet(object.PageSize) ? globalThis.Number(object.PageSize) : undefined,
      SearchTerm: isSet(object.SearchTerm) ? globalThis.String(object.SearchTerm) : undefined,
      SortColumn: isSet(object.SortColumn) ? globalThis.String(object.SortColumn) : undefined,
    };
  },

  toJSON(message: PagingInfo): unknown {
    const obj: any = {};
    if (message.PageIndex !== undefined) {
      obj.PageIndex = Math.round(message.PageIndex);
    }
    if (message.PageSize !== undefined) {
      obj.PageSize = Math.round(message.PageSize);
    }
    if (message.SearchTerm !== undefined) {
      obj.SearchTerm = message.SearchTerm;
    }
    if (message.SortColumn !== undefined) {
      obj.SortColumn = message.SortColumn;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PagingInfo>, I>>(base?: I): PagingInfo {
    return PagingInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PagingInfo>, I>>(object: I): PagingInfo {
    const message = createBasePagingInfo();
    message.PageIndex = object.PageIndex ?? undefined;
    message.PageSize = object.PageSize ?? undefined;
    message.SearchTerm = object.SearchTerm ?? undefined;
    message.SortColumn = object.SortColumn ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
